import { Component, OnInit } from '@angular/core';
import { UcionicaService } from './ucionica-popis.service';
import * as toastr from 'toastr';
import { Ucionica } from './ucionica-popis';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import { FormGroup, FormBuilder } from '@angular/forms';

declare var moment: any;
import * as alertify from 'alertify.js';
import { AppConfig } from '../../../config';
@Component({
  selector: 'app-ucionica-popis',
  templateUrl: './ucionica-popis.component.html',
  styleUrls: ['./ucionica-popis.component.css'],
  providers: [UcionicaService]
})
export class UcionicaPopisComponent implements OnInit {

  URL: any = AppConfig.IPfile;
  accessToken: any = localStorage.getItem('tokenSql');

  naziv: string;
  grad: string;

  myDatePickerOptions = {
		todayBtnTxt: 'Danas',
		dateFormat: 'dd.mm.yyyy',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		height: '34px',
		width: '100%',
		inline: false,
		selectionTxtFontSize: '16px',
		dayLabels: {su: 'Ned', mo: 'Pon', tu: 'Uto', we: 'Sri', th: 'Čet', fr: 'Pet', sa: 'Sub'},
		monthLabels: { 1: 'Sij', 2: 'Velj', 3: 'Ožu', 4: 'Tra', 5: 'Svi', 6: 'Lip', 7: 'Srp', 8: 'Kol', 9: 'Ruj', 10: 'Lis', 11: 'Stu', 12: 'Pro' }
	};

  sveUcionice: Ucionica[] = [];
  ucionicaOptions: DataTables.Settings = {};
  ucionicaTrigger: Subject<Ucionica> = new Subject();

  vrsta: string;

  datumOd: any;
  datumDo: any;
  datumOd_provjera: any;
  datumDo_provjera: any;
  datumprovjera: number = 1;
  datumraneprijave: any;
  datumkasneprijave: any;
  datumraneprijave_provjera: any;
  datumkasneprijave_provjera: any;
  datumprovjera2: number = 1;
  
  // objektZaSlanje = {
  //   'naziv': '',
  //   'vrstaEdukacije': '',
  //   'grad': '',
  //   'datumOd': '',
  //   'datumDo': ''
  // };


  ucionicaForma: FormGroup;
  ucionicaEditForma: FormGroup;

  vrstaEdukacije: any = 'all';

  disableSelect: any;
  disabledIndividualno: boolean = false;

  silabusSpreman: boolean = false;
  cjelovitiSilabus: string;
  idUcionica: string;
  cekamSilabus: boolean = false;

  constructor(
    private _fb: FormBuilder,
    public _router: Router,
    private _ucionicaService: UcionicaService
  ) {

    // let myDate = new Date();
    // myDate.setDate(myDate.getDate() + 1);
    // let danasnjiDatum = new Date().toISOString();
    // this.datumOd = moment(danasnjiDatum).format('DD.MM.YYYY.');
    // this.datumOdSlanje = moment(this.datumOd).format('YYYY-MM-DD');
    // let sutrasnjiDatum = myDate.toISOString();
    // this.datumDo = moment(sutrasnjiDatum).format('DD.MM.YYYY.');
    // this.datumDoSlanje = moment(this.datumDo).format('YYYY-MM-DD');
          
  }

  ngOnInit() {
    this.dohvati();
    this.vrsta = localStorage.getItem('vrsta');
    //Tablica početak
    this.ucionicaOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.ucionicaForma = this._fb.group({
      naziv: [''],
      vrstaEdukacije: [''],
      trajanjeEdukacije: [''],
      grad: [''],
      datumOd: [''],
      datumDo: [''],
      cijena: [''],
      popustranaprijava: [''],
      popustdvapolaznika: [''],
      popusttripolaznika: [''],
      datumraneprijave: [''],
      datumkasneprijave: [''],
      prikazivise: [''],
      cjelovitisilabus: [''],
      osnovneikomercijalneinformacije: [''],
      infovideo: [''],
      promovideo: [''],
      prikazweb: [''],
      individualno: ['']
    });
    this.ucionicaEditForma = this._fb.group({
      iducionica: [''],
      naziv: [''],
      vrstaEdukacije: [''],
      trajanjeEdukacije: [''],
      grad: [''],
      datumOd: [''],
      datumDo: [''],
      cijena: [''],
      popustranaprijava: [''],
      popustdvapolaznika: [''],
      popusttripolaznika: [''],
      datumraneprijave: [''],
      datumkasneprijave: [''],
      prikazivise: [''],
      cjelovitisilabus: [''],
      osnovneikomercijalneinformacije: [''],
      infovideo: [''],
      promovideo: [''],
      prikazweb: [''],
      otkaziedukaciju: [''],
      individualno: ['']
    });
  }

  dohvati(){
    this.sveUcionice = [];
    this._ucionicaService.dohvatiUcionice({'idkorisnik': localStorage.getItem('userId'), 'admin': localStorage.getItem('vrsta'), 'vrstaedukacije': this.vrstaEdukacije}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['uc_datumod'] && res.data[i]['uc_datumdo']){
            this.sveUcionice.push({
              'id': res.data[i]['iducionica'],
              'wp_id': res.data[i]['uc_wpiducionica'],
              'naziv': res.data[i]['uc_naziv'],
              'vrstaEdukacije': res.data[i]['uc_vrstaEdukacije'],
              'trajanjeEdukacije': res.data[i]['uc_trajanjeEdukacije'],
              'grad': res.data[i]['uc_grad'],
              'datumOd': moment(res.data[i]['uc_datumod']).format('DD.MM.YYYY.'),
              'datumDo': moment(res.data[i]['uc_datumdo']).format('DD.MM.YYYY.'),
              'cijena': res.data[i]['uc_cijena'],
              'popustranaprijava': res.data[i]['uc_popustranaprijava'],
              'popustdvapolaznika': res.data[i]['uc_popustdvapolaznika'],
              'popusttripolaznika': res.data[i]['uc_popusttripolaznika'],
              'datumraneprijave': res.data[i]['datumraneprijaveprikaz'],
              'datumkasneprijave': res.data[i]['datumkasneprijaveprikaz'],
              'prikazivise': res.data[i]['uc_prikazivise'],
              'cjelovitisilabus': res.data[i]['uc_preuzimanjecjelovitogsilabusa'],
              'osnovneikomercijalneinformacije': res.data[i]['uc_osnovneikomercijalneinformacije'],
              'infovideo': res.data[i]['uc_infovideo'],
              'promovideo': res.data[i]['uc_promovideo'],
              'brojpolaznika': res.data[i]['brojpolaznika'],
              'statusucionice': res.data[i]['uc_status'],
              'polozio': res.data[i]['ku_polozio'] || 0,
              'prikazweb': res.data[i]['uc_prikazweb']
            });
          } else {
            this.sveUcionice.push({
              'id': res.data[i]['iducionica'],
              'wp_id': res.data[i]['uc_wpiducionica'],
              'naziv': res.data[i]['uc_naziv'],
              'vrstaEdukacije': res.data[i]['uc_vrstaEdukacije'],
              'trajanjeEdukacije': res.data[i]['uc_trajanjeEdukacije'],
              'grad': res.data[i]['uc_grad'],
              'datumOd': null,
              'datumDo': null,
              'cijena': res.data[i]['uc_cijena'],
              'popustranaprijava': res.data[i]['uc_popustranaprijava'],
              'popustdvapolaznika': res.data[i]['uc_popustdvapolaznika'],
              'popusttripolaznika': res.data[i]['uc_popusttripolaznika'],
              'datumraneprijave': res.data[i]['datumraneprijaveprikaz'],
              'datumkasneprijave': res.data[i]['datumkasneprijaveprikaz'],
              'prikazivise': res.data[i]['uc_prikazivise'],
              'cjelovitisilabus': res.data[i]['uc_preuzimanjecjelovitogsilabusa'],
              'osnovneikomercijalneinformacije': res.data[i]['uc_osnovneikomercijalneinformacije'],
              'infovideo': res.data[i]['uc_infovideo'],
              'promovideo': res.data[i]['uc_promovideo'],
              'brojpolaznika': res.data[i]['brojpolaznika'],
              'statusucionice': res.data[i]['uc_status'],
              'polozio': res.data[i]['ku_polozio'] || 0,
              'prikazweb': res.data[i]['uc_prikazweb']
            });
          }
        }
        this.ucionicaTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  
  // provjeraDatumaOd(event:any) {
  //   // this.datumOd = event.date.year + '-' + event.date.month + '-' + event.date.day;
  // }

  // provjeraDatumaDo(event:any) {
  //   this.datumDo = event.date.year + '-' + event.date.month + '-' + event.date.day;
  // }

  provjeriDatumOd(event:any){
    //console.log(event);
    this.datumOd_provjera = moment(event.jsdate).format('YYYY-MM-DD');
    //console.log('datumOd_provjera: ', this.datumOd_provjera);
    if(this.datumDo_provjera){
      if(this.datumOd_provjera != 'Invalid date'){
        if(this.datumOd_provjera <= this.datumDo_provjera) {
          //console.log('datumOd je manji od datumDo ...uredu je...');
        }else{
          this.datumprovjera = 0;
          setTimeout(() => {
            this.datumprovjera = 1;
          }, 4000);
        }
      }
    }
  }

  provjeriDatumDo(event:any){
    //console.log(event);
    this.datumDo_provjera = moment(event.jsdate).format('YYYY-MM-DD');
    //console.log('datumDo_provjera: ', this.datumDo_provjera);
    if(this.datumOd_provjera){
      if(this.datumOd_provjera != 'Invalid date'){
        if(this.datumOd_provjera > this.datumDo_provjera){
          this.datumprovjera = 0;
          setTimeout(() => {
            this.datumprovjera = 1;
          }, 4000);
        }else{
          //console.log('datumOd je manji od datumDo ..uredu je..');
        }
      }
    }
  }

  provjeriDatumRaneprijave(event:any){
    //console.log(event);
    this.datumraneprijave_provjera = moment(event.jsdate).format('YYYY-MM-DD');
    //console.log('datumraneprijave_provjera: ', this.datumraneprijave_provjera);
    if(this.datumkasneprijave_provjera){
      if(this.datumraneprijave_provjera != 'Invalid date'){
        if(this.datumraneprijave_provjera <= this.datumkasneprijave_provjera) {
          //console.log('datumraneprijave je manji od datumkasneprijave ...uredu je...');
        }else{
          this.datumprovjera2 = 0;
          setTimeout(() => {
            this.datumprovjera2 = 1;
          }, 4000);
        }
      }
    }
  }

  provjeriDatumKasneprijave(event:any){
    //console.log(event);
    this.datumkasneprijave_provjera = moment(event.jsdate).format('YYYY-MM-DD');
    //console.log('datumkasneprijave_provjera: ', this.datumkasneprijave_provjera);
    if(this.datumraneprijave_provjera){
      if(this.datumraneprijave_provjera != 'Invalid date'){
        if(this.datumraneprijave_provjera > this.datumkasneprijave_provjera){
          this.datumprovjera2 = 0;
          setTimeout(() => {
            this.datumprovjera2 = 1;
          }, 4000);
        }else{
          //console.log('datumraneprijave je manji od datumkasneprijave ..uredu je..');
        }
      }
    }
  }

  ponistiSate(event){
    //console.log(event.target.value);
    if (event.target.value == 2) {
      //console.log('...ponistavam sate...');
      this.ucionicaForma.controls['trajanjeEdukacije'].reset();
    }
  }

  clickIndividualno(check_data){
    //console.log(check_data);
    /*
    if(check_data == true){
      this.disableSelect = true;
      this.ucionicaForma.get('grad').setValue('Individualno');
      this.ucionicaForma.get('datumOd').setValue('');
    }else if(check_data == false){
      this.disableSelect = false;
      this.ucionicaForma.controls['grad'].reset();
      this.ucionicaForma.controls['datumOd'].reset();
    }
    */
    if(check_data == true){
     this.ucionicaForma.controls['grad'].setValue('Individualno');
      this.ucionicaForma.controls['grad'].disable();
      this.ucionicaForma.controls['datumOd'].setValue('');
      this.ucionicaForma.controls['datumOd'].disable();
      this.ucionicaForma.controls['datumDo'].setValue('');
      this.ucionicaForma.controls['datumDo'].disable();
      this.ucionicaForma.controls['datumraneprijave'].setValue('');
      this.ucionicaForma.controls['datumraneprijave'].disable();
      this.ucionicaForma.controls['datumkasneprijave'].setValue('');
      this.ucionicaForma.controls['datumkasneprijave'].disable();
    }else if(check_data == false){
      this.ucionicaForma.controls['grad'].reset();
      this.ucionicaForma.controls['grad'].enable();
      this.ucionicaForma.controls['datumOd'].enable();
      this.ucionicaForma.controls['datumDo'].enable();
      this.ucionicaForma.controls['datumraneprijave'].enable();
      this.ucionicaForma.controls['datumkasneprijave'].enable();
    }
  }

  kreirajUcionicu(ucionicaForma){
    //console.log(ucionicaForma);

    let prikazwebzaslanje;
    if(ucionicaForma.value.prikazweb == true){
      prikazwebzaslanje = 1;
    } else {
      prikazwebzaslanje = 0;
    }

    let datum1; 
    let datum2;
    if(ucionicaForma.value.datumOd){
      if(ucionicaForma.value.datumOd.jsdate){
        datum1 = moment(ucionicaForma.value.datumOd.jsdate).format('YYYY-MM-DD');
      } else {
        datum1 = '';
      }
    }
    if(ucionicaForma.value.datumDo){
      if(ucionicaForma.value.datumDo.jsdate){
        datum2 = moment(ucionicaForma.value.datumDo.jsdate).format('YYYY-MM-DD');
      } else {
        datum2 = '';
      }
    }

    let objektZaSlanje = {
      'naziv': ucionicaForma.value.naziv,
      'vrstaEdukacije': ucionicaForma.value.vrstaEdukacije,
      'trajanjeEdukacije': ucionicaForma.value.trajanjeEdukacije,
      'grad': ucionicaForma.value.individualno==true ? 'Individualno': ucionicaForma.value.grad,
      'datumOd': ucionicaForma.value.individualno==true ? '': datum1,
      'datumDo': ucionicaForma.value.individualno==true ? '': datum2,
      'cijena': ucionicaForma.value.cijena,
      'popustranaprijava': ucionicaForma.value.popustranaprijava,
      'popustdvapolaznika': ucionicaForma.value.popustdvapolaznika,
      'popusttripolaznika': ucionicaForma.value.popusttripolaznika,
      'datumraneprijave': ucionicaForma.value.individualno==true ? '': moment(ucionicaForma.value.datumraneprijave.jsdate).format('YYYY-MM-DD'),
      'datumkasneprijave': ucionicaForma.value.individualno==true ? '': moment(ucionicaForma.value.datumkasneprijave.jsdate).format('YYYY-MM-DD'),
      'prikazivise': ucionicaForma.value.prikazivise,
      'preuzimanjecjelovitogsilabusa': ucionicaForma.value.cjelovitisilabus,
      'osnovneikomercijalneinformacije': ucionicaForma.value.osnovneikomercijalneinformacije,
      'infovideo': ucionicaForma.value.infovideo,
      'promovideo': ucionicaForma.value.promovideo,
      'prikazweb': prikazwebzaslanje
    };
    //console.log(objektZaSlanje);

    if(objektZaSlanje.naziv){
      if(objektZaSlanje.grad){
        if(objektZaSlanje.vrstaEdukacije){
          if(objektZaSlanje.datumOd != undefined && objektZaSlanje.datumDo != undefined){
            this._ucionicaService.kreirajUcionicu(objektZaSlanje).subscribe(res => {
              //console.log(res);
              if(res.success == true){
                toastr.success("Uspješno dodana učionica!");
                $('#ucionicaTablica').DataTable().destroy();
                this.dohvati();
              } else {
                toastr.error(res.message);
              }
            });
          } else {
            toastr.error('Unesite datum!');
          }
        } else {
          toastr.error('Odaberite vrstu edukacije!');
        }
      } else {
        toastr.error('Unesite grad učionice!');
      }
    } else {
      toastr.error('Unesite naziv učionice!');
    }
  }

  pripremiPodatke(ucionica){
    // console.log(ucionica);
    this.ucionicaEditForma = this._fb.group({
      iducionica: ucionica['id'],
      naziv: ucionica['naziv'],
      vrstaEdukacije: ucionica['vrstaEdukacije'],
      trajanjeEdukacije: ucionica['trajanjeEdukacije'],
      grad: ucionica['grad'],
      datumOd: ucionica['datumOd'],
      datumDo: ucionica['datumDo'],
      cijena: ucionica['cijena'],
      popustranaprijava: ucionica['popustranaprijava'],
      popustdvapolaznika: ucionica['popustdvapolaznika'],
      popusttripolaznika: ucionica['popusttripolaznika'],
      datumraneprijave: ucionica['datumraneprijave'],
      datumkasneprijave: ucionica['datumkasneprijave'],
      prikazivise: ucionica['prikazivise'],
      cjelovitisilabus: ucionica['cjelovitisilabus'],
      osnovneikomercijalneinformacije: ucionica['osnovneikomercijalneinformacije'],
      infovideo: ucionica['infovideo'],
      promovideo: ucionica['promovideo'],
      prikazweb: ucionica['prikazweb'],
      otkaziedukaciju: ucionica['statusucionice']
    });
    this.idUcionica = this.ucionicaEditForma.value.iducionica;
    console.log(this.idUcionica);
    this.datumOd = ucionica['datumOd'];
    this.datumDo = ucionica['datumDo'];
    this.datumraneprijave = ucionica['datumraneprijave'];
    this.datumkasneprijave = ucionica['datumkasneprijave'];

    if(this.ucionicaEditForma.value.grad == 'Individualno'){
      this.disabledIndividualno = true;
    }else{
      this.disabledIndividualno = false;
    }

    this.silabusSpreman = false;
    this.cekamSilabus = false;

  }

  pripremaZaKreiranjeSilabusa(){
    this.silabusSpreman = false;
    this._ucionicaService.dohvati_idmodule_za_ucionicu({'iducionica': this.idUcionica}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        if(res.data.length == 0){
          toastr.error("Ne može se kreirati PDF! Ne postoje ID moduli!");
        } else {
          let tmpArray = [];
          res.data.forEach(element => {
            // console.log(element.idmodul);
            tmpArray.push(element.idmodul);
            if(res.data.length == tmpArray.length){
              this.kreirajSilabus(tmpArray);
            }
          });
        }
      } else {
        toastr.error(res.message);
      }
    });
  }

  kreirajSilabus(idmoduli){
    let objektZaKreiranjeSilabusa = {
      'iducionica': this.idUcionica,
      'nazivtablice': 'syllabus',
      'idmoduli': idmoduli
    };
    // console.log(objektZaKreiranjeSilabusa);
    this.cekamSilabus = true;
    this._ucionicaService.kreiranje_syllabusa(objektZaKreiranjeSilabusa).subscribe(res => {
      console.log(res);
      if(res.success == true){
        this.cjelovitiSilabus = res.data;
        this.silabusSpreman = true;
        this.cekamSilabus = false;
      } else {
        toastr.error(res.message);
        this.silabusSpreman = false;
        this.cekamSilabus = false;
      }
    }, err => {
      toastr.error("Greška! PDF silabus se nije kreirao!");
      this.cekamSilabus = false;
      }
    );
  }

  urediUcionicu(ucionica){
    //console.log(ucionica);
    let datum1; 
    let datum2;
    if(ucionica.value.datumOd){
      if(ucionica.value.datumOd.jsdate){
        datum1 = moment(ucionica.value.datumOd.jsdate).format('YYYY-MM-DD');
      } else {
        datum1 = moment(ucionica.value.datumOd,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }
    if(ucionica.value.datumDo){
      if(ucionica.value.datumDo.jsdate){
        datum2 = moment(ucionica.value.datumDo.jsdate).format('YYYY-MM-DD');
      } else {
        datum2 = moment(ucionica.value.datumDo,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }

    if(ucionica.value.vrstaEdukacije == 2){
      ucionica.value.trajanjeEdukacije = '';
    }

    let datum_rane_prijave;
    let datum_kasne_prijave;
    if(ucionica.value.datumraneprijave){
      if(ucionica.value.datumraneprijave.jsdate){
        datum_rane_prijave = moment(ucionica.value.datumraneprijave.jsdate).format('YYYY-MM-DD');
      }else{
        datum_rane_prijave = moment(ucionica.value.datumraneprijave,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }
    if(ucionica.value.datumkasneprijave){
      if(ucionica.value.datumkasneprijave.jsdate){
        datum_kasne_prijave = moment(ucionica.value.datumkasneprijave.jsdate).format('YYYY-MM-DD');
      }else{
        datum_kasne_prijave = moment(ucionica.value.datumkasneprijave,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }

    let prikazwebzaslanje;
    if(ucionica.value.prikazweb == true){
      prikazwebzaslanje = 1;
    } else {
      prikazwebzaslanje = 0;
    }

    let otkaziedukacijuzaslanje;
    if(ucionica.value.otkaziedukaciju == true){
      otkaziedukacijuzaslanje = 1;
    } else {
      otkaziedukacijuzaslanje = 0;
    }

    let objektZaSlanje = {
      iducionica: ucionica.value.iducionica,
      naziv: ucionica.value.naziv,
      vrstaEdukacije: ucionica.value.vrstaEdukacije,
      trajanjeEdukacije: ucionica.value.trajanjeEdukacije,
      grad: ucionica.value.grad,
      datumOd: datum1,
      datumDo: datum2,
      cijena: ucionica.value.cijena,
      popustranaprijava: ucionica.value.popustranaprijava,
      popustdvapolaznika: ucionica.value.popustdvapolaznika,
      popusttripolaznika: ucionica.value.popusttripolaznika,
      datumraneprijave: datum_rane_prijave,
      datumkasneprijave: datum_kasne_prijave,
      prikazivise: ucionica.value.prikazivise,
      preuzimanjecjelovitogsilabusa: ucionica.value.cjelovitisilabus,
      osnovneikomercijalneinformacije: ucionica.value.osnovneikomercijalneinformacije,
      infovideo: ucionica.value.infovideo,
      promovideo: ucionica.value.promovideo,
      prikazweb: prikazwebzaslanje,
      otkaziedukaciju: otkaziedukacijuzaslanje
    }
    //console.log(objektZaSlanje);

    this._ucionicaService.urediUcionicu(objektZaSlanje).subscribe(res => {
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#ucionicaTablica').DataTable().destroy();
        this.dohvati();
      } else {
        toastr.error(res.message);
      }
    });

  }

  kopirajUcionicu(ucionica){
    let ovo = this;
    alertify
    .okBtn("Umnoži")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite umnožiti učionicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.kopiraj({idkorisnik: localStorage.getItem('userId'), 'iducionica': ucionica.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Učionica uspješno kopirana...");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste umnožavanja učionice.');
    });
  }

  obrisiUcionicuAlert(ucionica){
    let ovo = this;
    alertify
    .okBtn("Da")
    .cancelBtn("Ne")
    .confirm("Jeste li sigurni da želite obrisati učionicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo.obrisiUcionicu(ucionica);
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja učionice.');
    });
  }

  obrisiUcionicu(ucionica){
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Obriši učionicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.brisanjeUcionice({'iducionica': ucionica.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Uspješno obrisana učionica!");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja učionice.');
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ucionica-popis/ucionica-popis.component.ts